/**
 * Configuration pour l'environnement de STAGING/RECETTE
 * Ce fichier est utilisé pour les tests avant production
 */
export const environment = {
  production: false,
  env: 'staging',
  
  // Configuration Keycloak
  keycloak: {
    url: 'https://auth.cineri.sn',
    realm: 'sigesr',
    clientId: 'portal-sigesr',
    checkLoginIframe: true,
  },
  
  // URLs des APIs
  api: {
    baseUrl: 'https://api-staging.cineri.sn/api',
    timeout: 30000,
  },
  
  // Options de logging
  logging: {
    level: 'info',
    enableConsole: true,
    enableKeycloakLogs: true,
  },
  
  // Options SSR
  ssr: {
    enabled: true,
    prerender: false,
  },
  
  // Feature flags
  features: {
    enableAnalytics: true,
    enableErrorTracking: true,
  },
};